import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "../utils/app.utils";

interface GuestRouteProps {
    children: JSX.Element;
}

const GuestRoute: React.FC<GuestRouteProps> = ({ children }) => {
    const token = getToken();
    const location = useLocation();

    if (token) {
        return <Navigate to={location.state?.from?.pathname || "/"} replace />;
    }

    return children;
};

export default GuestRoute;
